import * as booking from 'services/booking';

export const BOOKING_DATE_SEL = 'BOOKING_DATE_SEL';
export const BOOKING_TIME_SEL = 'BOOKING_TIME_SEL';
export const BOOKING_STATS_SEL = 'BOOKING_STATS_SEL';

// 예약 목록
export const BookingDateSel = (params) => ({
  type: BOOKING_DATE_SEL,
  payload: {
    promise: booking.BookingDateSel(params)
  }
});

// 예약 상세
export const BookingTimeSel = (params) => {
  return {
    type: BOOKING_TIME_SEL,
    payload: {
      promise: booking.BookingTimeSel(params)
    }
  };
};

// 예약 통계
export const BookingStatsSel = (params) => ({
  type: BOOKING_STATS_SEL,
  payload: {
    promise: booking.BookingStatsSel(params)
  }
});
